import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'possessive'
})
export class PossessivePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value.endsWith('s') || value.endsWith('S') ? `${value}'` : `${value}'s`;
  }
}

